import { injectScript } from "./dom";

let twqLoaded = false;
export const loadTwitterSDK =  (apikey) => {
  if (!global.twq) {
    const twq = (global.twq = function() {
      twq.exe ? twq.exe.apply(twq, arguments) : twq.queue.push(arguments);
    });
    twq.version = '1.1';
    twq.queue = [];
     injectScript('https://static.ads-twitter.com/uwt.js', () => !twqLoaded);
    twqLoaded = true;
    twq('config',apikey);
  }
  return global.twq;
};
